import React from "react";
import Layout from "../components/Layout";

const NotFoundPage = () => (
  <Layout errorPage>
    <div className="mt-10 max-w-page px-5">
      <a href="/">
        <button type="button" className="mb-4">
          {"< Back"}
        </button>
      </a>
      <h1 className="text-4xl font-bold">
        Sorry<span className="text-primary">.</span>
      </h1>
      <p>
        <span className="font-bold text-lg">
          The page you requested was not found.
        </span>
      </p>
    </div>
  </Layout>
);

export default NotFoundPage;
